export type Maybe<T> = T | undefined;
export type Nullable<T> = T | null;
export type Optional<T> = T | null | undefined;

export type BaseStoreState<T> = {
  loading: boolean;
  error: any;
  data: T;
};

export enum FORM_TYPES {
  CIOMS = 'CIOMS',
  PREGNANCY = 'PREGNANCY',
  SAE_AESI = 'SAE_AESI',
  ADVERSE_EVENTS = 'ADVERSE_EVENTS',
}

export enum USER_ROLES {
  USER = 'USER',
  MONITOR = 'MONITOR',
  ADMIN = 'ADMIN',
}

export interface FormDTO {
  _id: string;
  creator: string;
  type: FORM_TYPES;
  study: string;
  locked: boolean;
  data: Record<string, any>;
  subject: string;
  center: string;
  saeNumber?: number;
}

export interface GetFormQueryDto {
  user?: string;
  type?: string;
  study?: string;
}

export type UpdateFormBodyDto = Partial<FormDTO> & Pick<FormDTO, '_id'>;

// NOTE (2026-09-09, audit trail - stage 2 of 3): types for the new
// read-only GET /forms/:id/audit-log endpoint and the "Change History"
// panel built on top of it. These do not change FormDTO or how existing
// forms are read/saved.
export interface AuditFieldChangeDTO {
  field: string;
  oldValue: unknown;
  newValue: unknown;
}

export interface AuditLogEntryDTO {
  _id: string;
  form: string;
  formType: FORM_TYPES;
  action: 'CREATE' | 'UPDATE';
  user?: Pick<UserDTO, '_id' | 'firstName' | 'lastName' | 'email'>;
  changes: AuditFieldChangeDTO[];
  createdAt: string;
}

export interface LoginBody extends JSON {
  email: string;
  password: string;
}

export interface StudyDTO extends JSON {
  _id: string;
  name: string;
  protocolNumber: string;
  ip: string;
}

export interface UserDTO {
  _id: string;
  email: string;
  password?: string;
  role: USER_ROLES;
  firstName: string;
  lastName: string;
}

export interface DownloadFormQuery {
  study?: string[];
  center?: string[];
  type?: string[];
  subject?: string[];
  // "<subject>|<saeNumber>" pairs - the same subject can have multiple SAE
  // cases (each with its own SAE Number), so `subject` alone can't pick out
  // a single case. Used by the "Download by Participant(s)" picker.
  subjectSaeNumber?: string[];
  allFields?: boolean;
}

export interface SendResetEmailDto {
  email: string;
}

export interface ValidateResetTokenDto {
  token: string;
}

export interface ResetPasswordDto {
  token: string;
  password: string;
}
